var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("c-tab", {
    attrs: {
      type: "horizon",
      dense: true,
      inlineLabel: true,
      tabItems: _vm.tabItems,
      height: _vm.tabHeight,
    },
    on: {
      "update:tabItems": function ($event) {
        _vm.tabItems = $event
      },
      "update:tab-items": function ($event) {
        _vm.tabItems = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (tab) {
          return [
            _c(tab.component, {
              tag: "component",
              attrs: { param: _vm.popupParam },
              on: { closePopup: _vm.closePopup },
            }),
          ]
        },
      },
    ]),
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v
      },
      expression: "tab",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }